"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _addPoint = _interopRequireDefault(require("./addPoint"));
var _index = _interopRequireDefault(require("@/components/goodList/index"));
var _storePoint = require("@/api/storePoint");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'Point',
  components: {
    systemStore: _addPoint.default,
    goodList: _index.default
  },
  data: function data() {
    return {
      artFrom: {
        page: 1,
        limit: 20,
        status: '1',
        keywords: ''
      },
      loading: false,
      tableData: [],
      total: 0,
      headerCount: {},
      // 库存编辑相关
      stockDialogVisible: false,
      stockLoading: false,
      stockForm: {
        storeId: null,
        storeName: '',
        stockItems: []
      },
      // 商品选择相关
      productSelectorVisible: false,
      selectedProducts: [],
      // 库存明细弹窗相关
      detailDialogVisible: false,
      currentStoreId: null,
      currentStoreName: '',
      currentStockDetails: []
    };
  },
  created: function created() {
    this.storeGetCount();
    this.tableList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    isNumber: function isNumber(val) {
      return typeof val === 'number' && !Number.isNaN(val);
    },
    //头部数量显示；
    storeGetCount: function storeGetCount() {
      var that = this;
      (0, _storePoint.storeGetCountApi)({
        keywords: this.artFrom.keywords
      }).then(function (res) {
        that.headerCount = res;
      });
    },
    //表格列表
    tableList: function tableList() {
      var that = this;
      that.loading = true;
      (0, _storePoint.storeListApi)(that.artFrom).then(function (res) {
        that.loading = false;
        that.tableData = res.list;
        that.total = res.total;
      });
    },
    //切换页数
    pageChange: function pageChange(index) {
      this.artFrom.page = index;
      this.tableList();
    },
    //切换显示条数
    sizeChange: function sizeChange(index) {
      this.artFrom.limit = index;
      this.tableList();
    },
    //头部切换
    onClickTab: function onClickTab() {
      // this.artFrom.keywords = '';
      this.tableList();
    },
    //搜索
    search: function search() {
      this.artFrom.page = 1;
      this.tableList();
      this.storeGetCount();
    },
    //是否显示
    onchangeIsShow: function onchangeIsShow(id, isShow) {
      var that = this;
      (0, _storePoint.storeUpdateStatusApi)({
        id: id,
        status: isShow
      }).then(function () {
        that.$message.success('操作成功');
        that.tableList();
        that.storeGetCount();
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    // 恢复
    storeRecovery: function storeRecovery(id) {
      var _this = this;
      this.$modalSure('恢复门店吗？').then(function () {
        (0, _storePoint.storeRecoveryApi)({
          id: id
        }).then(function () {
          _this.$message.success('恢复成功');
          _this.storeGetCount();
          _this.tableList();
        });
      });
    },
    //刪除
    storeDelete: function storeDelete(id) {
      var that = this;
      that.$modalSure('删除门店吗？').then(function () {
        (0, _storePoint.storeDeleteApi)({
          id: id
        }).then(function () {
          that.$message.success('删除成功');
          that.storeGetCount();
          that.tableList();
        });
      });
    },
    allDelete: function allDelete(id) {
      var _this2 = this;
      this.$modalSure('删除门店吗？').then(function () {
        (0, _storePoint.allDeleteApi)({
          id: id
        }).then(function () {
          _this2.$message.success('删除成功');
          _this2.storeGetCount();
          _this2.tableList();
        });
      });
    },
    //添加
    add: function add() {
      this.$refs.template.dialogFormVisible = true;
    },
    //编辑
    edit: function edit(id) {
      this.$refs.template.dialogFormVisible = true;
      this.$refs.template.getInfo(id);
    },
    // 批量编辑库存
    batchEditStock: function batchEditStock(row) {
      this.stockForm.storeId = row.id;
      this.stockForm.storeName = row.name;
      this.stockForm.stockItems = [];
      this.stockDialogVisible = true;
      this.stockLoading = false;
      this.selectedProducts = [];

      // 先加载该门店已有的库存商品列表，加载完成后再显示弹窗
      this.loadStoreStockList(row.id);
    },
    // 加载门店库存列表
    loadStoreStockList: function loadStoreStockList(storeId) {
      var _this3 = this;
      (0, _storePoint.getStoreStockListApi)(storeId).then(function (res) {
        if (res && res.length > 0) {
          // 过滤掉当前库存为0的商品
          _this3.stockForm.stockItems = res.filter(function (item) {
            return item.stock > 0;
          }).map(function (item) {
            return {
              productId: item.productId,
              productName: item.productName,
              productImage: item.productImage,
              stock: item.stock,
              newStock: item.stock // 初始化新库存等于当前库存
            };
          });
        }
      }).catch(function (error) {
        console.error('加载库存列表失败:', error);
        // 加载失败不影响后续操作，用户仍然可以手动选择商品
      });
    },
    // 显示商品选择器
    showProductSelector: function showProductSelector() {
      this.selectedProducts = this.stockForm.stockItems.map(function (item) {
        return {
          id: item.productId,
          image: item.productImage,
          storeName: item.productName
        };
      });
      this.productSelectorVisible = true;
    },
    // 处理商品选择
    handleProductSelected: function handleProductSelected(products) {
      var _this4 = this;
      if (!products || products.length === 0) {
        this.$message.warning('请选择商品');
        return;
      }
      var addedCount = 0;
      // 将选中的商品添加到库存编辑列表
      products.forEach(function (product) {
        // 检查是否已存在
        var exists = _this4.stockForm.stockItems.find(function (item) {
          return item.productId === product.id;
        });
        if (!exists) {
          _this4.stockForm.stockItems.push({
            productId: product.id,
            productName: product.storeName,
            productImage: product.image,
            stock: 0,
            // 当前库存为0（新增商品）
            newStock: 0 // 新库存初始为0
          });
          addedCount++;
        }
      });
      this.productSelectorVisible = false;
      if (addedCount > 0) {
        this.$message.success("\u5DF2\u6DFB\u52A0 ".concat(addedCount, " \u4E2A\u5546\u54C1"));
      } else {
        this.$message.info('所选商品已存在');
      }
    },
    // 移除商品
    removeProduct: function removeProduct(index) {
      this.stockForm.stockItems.splice(index, 1);
    },
    // 获取库存变化
    getStockChange: function getStockChange(row) {
      var change = row.newStock - row.stock;
      if (change > 0) {
        return "+".concat(change);
      } else if (change < 0) {
        return "".concat(change);
      }
      return '0';
    },
    // 获取库存变化样式
    getStockChangeClass: function getStockChangeClass(row) {
      var change = row.newStock - row.stock;
      if (change > 0) {
        return 'stock-increase';
      } else if (change < 0) {
        return 'stock-decrease';
      }
      return 'stock-no-change';
    },
    // 提交库存更新
    submitStockUpdate: function submitStockUpdate() {
      var _this5 = this;
      if (!this.stockForm.storeId) {
        this.$message.error('门店ID不能为空');
        return;
      }
      if (!this.stockForm.stockItems || this.stockForm.stockItems.length === 0) {
        this.$message.error('请至少选择一个商品');
        return;
      }

      // 提交时过滤：只提交有变化的商品（新库存不等于当前库存）或者新增商品（当前库存=0但新库存>0）
      var stockItems = this.stockForm.stockItems.filter(function (item) {
        return item.newStock !== item.stock;
      }).map(function (item) {
        return {
          productId: item.productId,
          stock: item.newStock
        };
      });
      if (stockItems.length === 0) {
        this.$message.info('库存没有变化，无需更新');
        return;
      }
      var requestData = {
        storeId: this.stockForm.storeId,
        stockItems: stockItems
      };
      this.stockLoading = true;
      (0, _storePoint.batchUpdateStockApi)(requestData).then(function () {
        _this5.$message.success("\u5E93\u5B58\u66F4\u65B0\u6210\u529F\uFF0C\u5171\u66F4\u65B0 ".concat(stockItems.length, " \u4E2A\u5546\u54C1"));
        _this5.stockDialogVisible = false;
        _this5.stockLoading = false;
        // 刷新列表
        _this5.tableList();
      }).catch(function () {
        _this5.stockLoading = false;
      });
    },
    // 显示库存明细
    showDetail: function showDetail(row) {
      if (!row.stockDetails || row.stockDetails.length === 0) {
        this.$message.info('该门店暂无商品库存信息');
        return;
      }
      this.currentStoreId = row.id;
      this.currentStoreName = row.name;
      this.currentStockDetails = row.stockDetails;
      this.detailDialogVisible = true;
    }
  }
};